import { Pipe, PipeTransform } from '@angular/core';
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";

@Pipe({
    name: 'modifyFieldConfigPipe'
})

export class ModifyFieldConfigPipe implements PipeTransform {
    public transform(fieldConfig: IFieldSpecs, modifications: Partial<IFieldSpecs>): IFieldSpecs {
        return {
            ...fieldConfig,
            ...modifications,
        };
    }
}